(() => {
  const initialized = new WeakSet();

  function initializeCloser(closer) {
    if (!closer || initialized.has(closer)) return;

    initialized.add(closer);

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let frame = null;

    const update = () => {
      frame = null;

      if (reducedMotion.matches || window.innerWidth < 620) {
        closer.style.setProperty('--kaqr-px', '0px');
        return;
      }

      const bounds = closer.getBoundingClientRect();
      if (bounds.bottom < 0 || bounds.top > window.innerHeight) return;

      const progress = (bounds.top + bounds.height / 2 - window.innerHeight / 2) / window.innerHeight;
      const clamped = Math.max(-1, Math.min(1, progress));
      closer.style.setProperty('--kaqr-px', `${(clamped * -28).toFixed(1)}px`);
    };

    const requestUpdate = () => {
      if (frame !== null) return;
      frame = window.requestAnimationFrame(update);
    };

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
    reducedMotion.addEventListener?.('change', requestUpdate);
    requestUpdate();
  }

  function initialize(root = document) {
    root.querySelectorAll('[data-ka-protocol-closer]').forEach(initializeCloser);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize());
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
